<template>
  <div class="box">
    <div class="tag-container" :class="{invalid: isInvalid}">
      <input 
        type="text"
        @keyup="tagkeyUpChange"
        @focusout="tagFocusOutChange"
        v-model="userInput" />
    </div>
  </div>
</template>

<script>
import { email } from 'vuelidate/lib/validators';

export default {
  name: 'TagInput',
  data () {
    return {
      invalid: false,
      emails: [],
      removeItem: null,
      tagContainer: document.querySelector('.tag-container'),
      input: document.querySelector('.tag-container input'),
      userInput: ''
    };
  },
  computed: {
    isInvalid () {
      return this.invalid;
    }
  },
  watch: {
    emails: function (val) {
      this.$emit('getInputs', {emails: val, invalid: this.isInvalid});
    },
    invalid: function (val) {
      this.$emit('getInputs', {emails: this.emails, invalid: val});
    }
  },
  mounted () {
    this.tagContainer = document.querySelector('.tag-container');
    this.input = document.querySelector('.tag-container input');
  },
  methods: {
    createTag (label) {
      const div = document.createElement('div');
      div.setAttribute('class', 'tag');
      const span = document.createElement('span');
      span.innerHTML = label;
      const closeIcon = document.createElement('i');
      closeIcon.setAttribute('class', 'fa fa-times');
      closeIcon.setAttribute('arial-hidden', 'true');
      closeIcon.setAttribute('data-item', label);
      closeIcon.addEventListener('click', this.removeEmail);
      div.appendChild(span);
      div.appendChild(closeIcon);
      return div;
    },

    clearTags () {
      document.querySelectorAll('.tag').forEach(tag => {
        tag.parentElement.removeChild(tag);
      })
    },

    addTags () {
      this.clearTags();
      this.emails.slice().reverse().forEach(tag => {
        this.tagContainer.prepend(this.createTag(tag));
      });
    },
    tagkeyUpChange() {
      if (this.userInput !== '' && this.userInput.length > 2) {
        if (this.userInput.endsWith(' ')) {
          this.invalid = false;
          let emailInput = this.userInput.replace(' ', '');
          if (!email(emailInput)) {
            this.invalid = true;
            return false;
          }
          if (this.validateEmail(emailInput)) {
            emailInput.split(' ').forEach(tag => {
              this.emails.push(tag);
            });

            this.addTags();
            this.userInput = '';
          }
        }
      }
    },
    tagFocusOutChange() {
      if (this.userInput !== '') {
        if (this.userInput.endsWith('')) {
          this.invalid = false;
          let emailInput = this.userInput;
          if (!email(emailInput)) {
            this.invalid = true;
            return false;
          }
          if (this.validateEmail(emailInput)) {
            emailInput.split(' ').forEach(tag => {
              this.emails.push(tag);
            });

            this.addTags();
            this.userInput = '';
          }
        }
      }
    },
    validateEmail(email){
      const emailPattern = /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailPattern.test(email);
    }, 
    removeEmail (e) {
      if (e.target.tagName === 'I') {
        const tagLabel = e.target.getAttribute('data-item');
        const index = this.emails.indexOf(tagLabel);
        this.emails = [...this.emails.slice(0, index), ...this.emails.slice(index + 1)];
        this.addTags();
      }
    }
  }
}
</script>

<style lang="scss">
.box {
  .tag-container {
    border: 1px solid #697B94;
    border-radius: 0.25rem;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: center;
    padding: 7px 15px;
    .tag {
      height: 30px;
      margin: 5px;
      padding: 5px 6px;
      border: 1px solid #ccc;
      border-radius: 3px;
      background: #eee;
      display: flex;
      align-items: center;
      color: #333;
      cursor: default;
      i {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 5px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    input {
      min-width: 50%;
      height: auto;
      padding: 5px;
      font-size: 16px;
      border: 0 !important;
      outline: none;
      flex: 1;
      margin: 0;
    }
  }
}

@media (max-width: 767px) {
  .box {
    .tag-container {
      .tag {
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 991px) {
  .box {
    .tag-container {
      .tag {
        min-height: 30px;
        height: auto;
        word-break: break-word;
      }
    }
  }
}
</style>